import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import Term from "./Term";
import { LocationContext } from "./locationContext";

const VenueBlock = ({ location, isMobile }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        padding: "40px 20px",
        flexWrap: "wrap",
        backgroundColor: "#ffffff",
        marginBottom: "40px",
        borderRadius: "18px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
      }}
    >
      <div style={{ maxWidth: "480px" }}>
        <div
          style={{
            backgroundColor: "#843c96",
            padding: "25px 30px",
            borderRadius: "10px",
            textAlign: "center",
            marginBottom: "25px",
            color: "white",
            fontWeight: "700",
            fontSize: isMobile ? "22px" : "28px",
            lineHeight: "38px",
          }}
        >
          {location.name.toUpperCase()} <br />
          <span
            style={{
              display: "inline-block",
              fontWeight: "900",
              fontSize: isMobile ? "26px" : "34px",
              letterSpacing: "2px",
              background:
                "linear-gradient(90deg, #ff7a00, #ffb300, #fff200, #ff4081)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
              textShadow: `
                                0 0 8px rgba(255,122,0,0.6),
                                0 0 16px rgba(255,179,0,0.5),
                                0 0 24px rgba(255,64,129,0.4)
                            `,
            }}
          >
            BRANDED SUMMER SALE
          </span>
        </div>

        <p style={{ color: "#555", textAlign: "center" }}>{location.address}</p>

        <p
          style={{
            fontSize: isMobile ? "20px" : "24px",
            fontWeight: "700",
            textAlign: "center",
          }}
        >
          India's Biggest Summer Sale
        </p>

        <p style={{ fontSize: "18px", textAlign: "center" }}>
          Date – {location.data} <br />
          Time 10 am to 10 pm
        </p>
      </div>

      <img
        src={location.img}
        alt={location.name}
        style={{
          width: isMobile ? "260px" : "380px",
          height: isMobile ? "200px" : "280px",
          objectFit: "cover",
          borderRadius: "12px",
          marginTop: "20px",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.25)",
        }}
        onError={(e) => (e.target.src = "/HOTEL.jpg")}
      />
    </div>
  );
};

const Venues = () => {
  const { locations } = useContext(LocationContext);

  const loc1Data = locations.Loc2;

  const navigate = useNavigate();

  const [selectedImage, setSelectedImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [couponSaved, setCouponSaved] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("coupon_saved");

    if (saved === "true") {
      setCouponSaved(true);
    }
  }, []);

  const takeScreenshot = async () => {
    const element = document.getElementById("coupon-card");
    if (!element) return;

    const style = document.createElement("style");

    style.innerHTML = `
            * {
                color: #000 !important;
                background-color: transparent !important;
                border-color: #000 !important;
                box-shadow: none !important;
            }

            #coupon-card,
            #coupon-card * {
                color: #fff !important;
                background: #000 !important;
            }
        `;

    document.head.appendChild(style);

    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#000",
      });

      const image = canvas.toDataURL("image/radission_blue.jpg");

      const link = document.createElement("a");
      link.href = image;
      link.download = `radission_blue.jpg`;
      link.click();

      localStorage.setItem("coupon_saved", "true");

      setCouponSaved(true);

      setTimeout(() => {
        setShowModal(false);
      }, 500);
    } catch (err) {
      console.error("Screenshot failed:", err);
      alert("Screenshot failed. Try again.");
    }

    document.head.removeChild(style);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* NAV */}
      <nav
        style={{
          display: "flex",
          gap: "12px",
          padding: "12px 16px",
          background: "#f7ecfb",
          borderRadius: "14px",
          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
          alignItems: "center",
          overflowX: "auto",
        }}
      >
        <button
          onClick={() => navigate("/")}
          style={{
            padding: "10px 18px",
            fontSize: "12px",
            fontWeight: "600",
            borderRadius: "999px",
            background: "linear-gradient(135deg, #b26cff, #e09af1)",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          Home
        </button>

        <button
          onClick={() => navigate("/location2")}
          style={{
            padding: "10px 18px",
            fontSize: "12px",
            fontWeight: "600",
            borderRadius: "999px",
            background: "linear-gradient(135deg, #b26cff, #e09af1)",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          2nd Location
        </button>

        <button
          onClick={() => navigate("/location3")}
          style={{
            padding: "10px 18px",
            fontSize: "12px",
            fontWeight: "600",
            borderRadius: "999px",
            background: "linear-gradient(135deg, #b26cff, #e09af1)",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          3rd Location
        </button>
      </nav>

      {/* VENUE */}
      <div style={{ padding: "20px" }}>
        <VenueBlock location={loc1Data} isMobile={isMobile} />
      </div>

      {/* COUPON SECTION */}
      <div
        style={{
          background:
            "linear-gradient(135deg, #24003a 0%, #3a0051 50%, #5b0080 100%)",
          padding: isMobile ? "30px 14px" : "60px 30px",
          border: isMobile ? "4px solid #ff4081" : "8px solid #ff4081",
          borderRadius: isMobile ? "22px" : "32px",
          maxWidth: "1100px",
          margin: "50px auto",
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
        }}
      >
        {/* Glow */}
        <div
          style={{
            position: "absolute",
            top: "-120px",
            right: "-120px",
            width: "250px",
            height: "250px",
            background: "rgba(255,64,129,0.18)",
            borderRadius: "50%",
            filter: "blur(40px)",
          }}
        />

        <div
          style={{
            position: "absolute",
            bottom: "-100px",
            left: "-100px",
            width: "220px",
            height: "220px",
            background: "rgba(255,179,0,0.18)",
            borderRadius: "50%",
            filter: "blur(40px)",
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 2,
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "space-between",
            gap: isMobile ? "30px" : "50px",
          }}
        >
          {/* LEFT CONTENT */}
          <div
            style={{
              flex: 1,
              color: "#fff",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            <div
              style={{
                display: "inline-block",
                background: "rgba(255,255,255,0.12)",
                padding: "8px 18px",
                borderRadius: "999px",
                fontSize: isMobile ? "12px" : "14px",
                fontWeight: "700",
                marginBottom: "18px",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              🔥 LIMITED TIME OFFER
            </div>

            <h2
              style={{
                fontSize: isMobile ? "38px" : "68px",
                lineHeight: isMobile ? "46px" : "74px",
                margin: 0,
                fontWeight: "900",
                letterSpacing: "-2px",
              }}
            >
              FLAT
            </h2>

            <div
              style={{
                fontSize: isMobile ? "72px" : "120px",
                fontWeight: "900",
                lineHeight: 1,
                margin: "8px 0",
                background: "linear-gradient(90deg,#fff200,#ff9100,#ff1744)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textShadow: "0 8px 30px rgba(255,145,0,0.35)",
              }}
            >
              300
            </div>

            <h3
              style={{
                fontSize: isMobile ? "28px" : "48px",
                marginTop: "0",
                marginBottom: "20px",
                fontWeight: "800",
                color: "#fff",
              }}
            >
              OFF
            </h3>

            <p
              style={{
                color: "#e5d8ee",
                fontSize: isMobile ? "15px" : "19px",
                lineHeight: "1.7",
                maxWidth: "500px",
                margin: isMobile ? "auto" : "0",
              }}
            >
              Save this exclusive summer sale coupon and show it at the venue to
              unlock your instant discount.
            </p>

            <button
              onClick={takeScreenshot}
              style={{
                marginTop: "28px",
                background: "linear-gradient(135deg,#ff1744,#ff9100)",
                color: "#fff",
                padding: isMobile ? "16px 22px" : "18px 34px",
                borderRadius: "16px",
                fontSize: isMobile ? "15px" : "18px",
                fontWeight: "800",
                border: "none",
                cursor: "pointer",
                width: isMobile ? "100%" : "auto",
                boxShadow: "0 10px 30px rgba(255,64,129,0.4)",
                transition: "0.3s ease",
              }}
            >
              📸 SAVE COUPON NOW
            </button>
          </div>

          {/* RIGHT COUPON */}
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div
              id="coupon-card"
              style={{
                position: "relative",
                width: "100%",
                maxWidth: isMobile ? "340px" : "480px",
                borderRadius: isMobile ? "20px" : "28px",
                overflow: "hidden",
                boxShadow: "0 25px 60px rgba(0,0,0,0.45)",
                border: "4px solid rgba(255,255,255,0.12)",
                background: "#000",
              }}
            >
              <img
                src="/images/hardoi.png"
                alt="Coupon"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "contain",
                  background: "#000",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* MODAL */}
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.88)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            padding: "20px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              borderRadius: "16px",
              overflow: "hidden",
              maxWidth: "520px",
              width: "100%",
              boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
            }}
          >
            {/* SCREENSHOT CARD */}
            <div
              id="coupon-card"
              style={{
                position: "relative",
                background: "#000",
              }}
            >
              <img
                src={selectedImage}
                alt="Selected Coupon"
                style={{
                  width: "100%",
                  display: "block",
                }}
              />

              {/* BADGE */}
              <div
                style={{
                  position: "absolute",
                  top: "8%",
                  left: "80%",
                  transform: "translateX(-50%)",
                  background: "rgba(0,0,0,0.75)",
                  color: "#fff",
                  padding: "8px 18px",
                  borderRadius: "20px",
                  fontWeight: "700",
                  fontSize: isMobile ? "12px" : "15px",
                  letterSpacing: "0.8px",
                  whiteSpace: "nowrap",
                }}
              >
                Summer Sale Coupon
              </div>
            </div>
          </div>

          {/* BUTTONS */}
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "flex",
              gap: "12px",
              marginTop: "20px",
              width: "100%",
              maxWidth: "520px",
            }}
          >
            <button
              onClick={takeScreenshot}
              style={{
                flex: 1,
                background: "#0036a3",
                color: "#fff",
                padding: "14px",
                borderRadius: "12px",
                fontSize: isMobile ? "14px" : "16px",
                fontWeight: "600",
                border: "none",
                cursor: "pointer",
              }}
            >
              📸 Save Coupon Screenshot
            </button>

            <button
              onClick={() => setShowModal(false)}
              style={{
                padding: "14px 20px",
                borderRadius: "12px",
                background: "#555",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                fontWeight: "600",
                fontSize: isMobile ? "14px" : "16px",
              }}
            >
              ✕ Close
            </button>
          </div>
        </div>
      )}

      <Term />
    </>
  );
};

export default Venues;
